import script from "./UpgradeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradeDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UpgradeDialog.vue?vue&type=style&index=0&id=345efdf2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345efdf2"]])

export default __exports__